import { ChargebackStatus } from "@/models/enum/chargeback-status";

export class ChargebackFilters {
    chargebackIds?: string[];
    dateFrom?: string;
    dateTo?: string;
    payeeCodes?: string[];
    accountNames?: string[];
    statuses?: ChargebackStatus[];
    vendorCentralStatuses?: string[];
    issueTypes?: string[];
    eans?: string[];
    asins?: string[];
    purchaseOrders?: string[];
    invoiceNumbers?: string[];
    reversalInvoiceNumbers?: string[];
}
